export default "__VITE_ASSET__BGxdQvSx__"